define( function() {
	"use strict";

	return [];
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/arr.js
// module id = 1003
// module chunks = 36